import axios from 'axios'
import { API_BASE_URL } from '../utils/config'
import qs from 'qs'

// 创建 axios 实例
const service = axios.create({
  baseURL: API_BASE_URL, // API 的基础URL
  timeout: 15000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  },
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 这里可以根据后端的响应结构做相应的处理
    if (res.code && res.code !== 200) {
      // 处理业务错误
      console.error('API Error:', res.msg)
      // Attach HTTP status code and response data to the error
      const error = new Error(res.msg || 'Error')
      error.response = {
        status: res.code,
        data: res
      }
      return Promise.reject(error)
    }
    return res
  },
  error => {
    // 处理 HTTP 错误
    console.error('Response error:', error)
    
    // 全局处理401未授权错误
    if (error.response && error.response.status === 401) {
      console.log('Unauthorized access, redirecting to login page')
      
      // 显示用户友好的提示信息
      if (window.$app && window.$app.config.globalProperties.$toast) {
        window.$app.config.globalProperties.$toast.add({
          severity: 'warn',
          summary: 'Session Expired',
          detail: 'Login expired, please login again',
          life: 3000,
          closable: false
        })
      }
      
      // 清除本地存储的token
      localStorage.removeItem('token')
      
      // 延迟跳转，让用户能看到提示信息
      setTimeout(() => {
        if (window.location.pathname !== '/login') {
          window.location.href = '/login'
        }
      }, 1500) // 延迟1.5秒跳转
      
      return Promise.reject(new Error('Unauthorized access'))
    }
    
    const message = error.response?.data?.message || error.message || 'Request failed'
    return Promise.reject(error)
  }
)

// 创建用于对象存储上传的axios实例（不需要Authorization头）
const storageService = axios.create({
  timeout: 30000, // 上传可能需要更长时间
})

// 创建用于长时间运行的请求的axios实例
const longRunningService = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000, // 2分钟超时
  headers: {
    'Content-Type': 'application/json'
  }
})

// 为长时间运行的请求添加请求拦截器
longRunningService.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('Long running request error:', error)
    return Promise.reject(error)
  }
)

// 为长时间运行的请求添加响应拦截器
longRunningService.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code && res.code !== 200) {
      console.error('API Error:', res.msg)
      return Promise.reject(new Error(res.msg || 'Error'))
    }
    return res
  },
  error => {
    console.error('Long running response error:', error)
    const message = error.response?.data?.message || error.message || 'Request failed'
    return Promise.reject(error)
  }
)

// 对象存储上传的响应拦截器
storageService.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.error('Storage upload error:', error)
    return Promise.reject(error)
  }
)

export default service
export { storageService, longRunningService } 